import { CUP_GRATITUDE_APIS } from "libs/apis/cup-of-gratitude.api";
import { RESOURCE_LIBRARy_APIS } from "libs/apis/resource-library.api";
import { USER_APIS } from "libs/apis/users.api";
import { useNavigate } from "react-router-dom";
import { successToaster } from "utils/helpers/common/alert-service";
import { CreateCupOfGratitudeDTO } from "utils/helpers/models/cup-gratitude/cup-gratitude.dto";
import { CreateResourceLibraryDTO } from "utils/helpers/models/resource-library/resource-library.dto";
import { UserDTO } from "utils/helpers/models/users/user.dto";

const useCupOfGratitude = () => {
  const navigate = useNavigate();
  const uploadFile = async (params: FormData): Promise<string | null> => {
    try {
      const response = await CUP_GRATITUDE_APIS.uploadFile(params);
      const { status = false, message = "", data = null } = response || {};

      if (status && data) {
        return data;
      }

      return null;
    } catch (error) {
      console.error("Upload failed", error);
      return null;
    }
  };

  const createCupOfGratitude = async (body: CreateCupOfGratitudeDTO) => {
    const response = await CUP_GRATITUDE_APIS.createCupOfGratitude(body);
    const { status = false } = response || {};
    if (status) {
      navigate(-1);
    }
  };

  const editCupOfGratitude = async (id: number, queryParams: any = {}) => {
    const response = await CUP_GRATITUDE_APIS.editCupOfGratitudes(
      id,
      queryParams
    );
    const { status = false } = response || {};
    if (status) {
      navigate(-1);
    }
  };

  const getCupOfGratitudesById = async (id: number, setData: Function) => {
    const response = await CUP_GRATITUDE_APIS.getCupOfGratitudesById(id);
    const { status = false, data = {} } = response || {};
    if (status) {
      setData(data);
    }
  };

  const getCupOfGratitude = async (
    setData: Function,
    queryParams: any = {}
  ) => {
    const response = await CUP_GRATITUDE_APIS.getCupOfGratitude(queryParams);
    console.log(response);
    const { status = false, data = null } = response || {};
    if (status) {
      const { content = [], offset = 0, count = 0 } = data || {};
      setData(content);
    }
  };

  return {
    uploadFile,
    createCupOfGratitude,
    getCupOfGratitude,
    editCupOfGratitude,
    getCupOfGratitudesById,
  };
};

export default useCupOfGratitude;
